import FacebookPixel from './FacebookPixel';

export default FacebookPixel;
